import React from "react"
import Banner from "./Banner"
import Design from "./Design"
import Logo from "./Logo"
import Video from "./Video"
import "./niradhi.scss"

const Niradhi = () => {
  return (
    <div>
      <Logo />
      <Banner />
      <Design />
      <Video />
    </div>
  )
}

export default Niradhi
